'use strict';
/* ════════════════════════════════════════
   WOODENXA THEME — wx.js
   ════════════════════════════════════════ */

var WX = (function() {

  /* ── CART ── */
  function addToCart(variantId, qty, btn) {
    if (!variantId) return;
    var orig = btn ? btn.innerHTML : '';
    if (btn) { btn.innerHTML = '...'; btn.disabled = true; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify({id: parseInt(variantId), quantity: qty || 1})
    })
    .then(function(r){ return r.json(); })
    .then(function() {
      if (btn) {
        btn.innerHTML = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M1.5 6l3.5 3.5L10.5 2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg> Added!';
        btn.style.background = '#2D6A4F';
        setTimeout(function(){ btn.innerHTML = orig; btn.style.background = ''; btn.disabled = false; }, 1700);
      }
      fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){ updateBadge(c.item_count); openCart(); });
    })
    .catch(function(){ if (btn) { btn.innerHTML = orig; btn.disabled = false; } });
  }

  function updateBadge(n) {
    document.querySelectorAll('.cart-pip').forEach(function(el){ el.textContent = n > 0 ? n : ''; el.style.display = n > 0 ? 'flex' : 'none'; });
  }

  function openCart() {
    var drawer = document.getElementById('cartDrawer');
    var ov = document.getElementById('cartOv');
    if (drawer) { drawer.classList.add('open'); document.body.style.overflow = 'hidden'; }
    if (ov) ov.classList.add('open');
    loadCartDrawer();
  }

  function closeCart() {
    var drawer = document.getElementById('cartDrawer');
    var ov = document.getElementById('cartOv');
    if (drawer) drawer.classList.remove('open');
    if (ov) ov.classList.remove('open');
    document.body.style.overflow = '';
  }

  function loadCartDrawer() {
    var body = document.getElementById('cdBody');
    if (!body) return;
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
      updateBadge(cart.item_count);
      if (!cart.item_count) {
        body.innerHTML = '<div class="cd-empty"><svg viewBox="0 0 44 44" fill="none"><path d="M5 5h5l6 24H36l5-17H14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><circle cx="20" cy="38" r="3" stroke="currentColor" stroke-width="1.8"/><circle cx="33" cy="38" r="3" stroke="currentColor" stroke-width="1.8"/></svg><h3>Your cart is empty</h3><p>Explore our handcrafted wooden collection</p><a href="/collections/all" class="btn-pri btn-sm" style="display:inline-flex;margin:0 auto" onclick="WX.closeCart()">Shop Now</a></div>';
        return;
      }
      var total = cart.total_price;
      var thresh = 50000; // Rs. 500 in paise
      var pct = Math.min(100, Math.round(total / thresh * 100));
      var rem = thresh - total;
      var shipHTML = total >= thresh
        ? '<div class="ship-bar-cart"><div class="ship-bar-txt"><span>🎉 Free delivery unlocked!</span></div><div class="ship-track"><div class="ship-fill" style="width:100%"></div></div></div>'
        : '<div class="ship-bar-cart"><div class="ship-bar-txt"><span>Add <strong>' + fmoney(rem) + '</strong> more for free delivery</span></div><div class="ship-track"><div class="ship-fill" style="width:' + pct + '%"></div></div></div>';
      var itemsHTML = cart.items.map(function(item){
        return '<div class="ci-wrap" data-line="' + item.variant_id + '">' +
          '<a href="' + item.url + '"><div class="ci-img"><img src="' + item.image + '" alt="' + item.title + '" loading="lazy" width="76" height="76"></div></a>' +
          '<div class="ci-info">' +
            '<a href="' + item.url + '" class="ci-name">' + item.product_title + '</a>' +
            (item.variant_title !== 'Default Title' ? '<span class="ci-var">' + item.variant_title + '</span>' : '') +
            '<div class="ci-row">' +
              '<div class="qty-c">' +
                '<button class="qty-b" onclick="WX.updateCart(' + item.variant_id + ',' + (item.quantity-1) + ')">−</button>' +
                '<span class="qty-v">' + item.quantity + '</span>' +
                '<button class="qty-b" onclick="WX.updateCart(' + item.variant_id + ',' + (item.quantity+1) + ')">+</button>' +
              '</div>' +
              '<span class="ci-price">' + fmoney(item.final_line_price) + '</span>' +
            '</div>' +
          '</div>' +
          '<button class="ci-rm" onclick="WX.updateCart(' + item.variant_id + ',0)"><svg viewBox="0 0 10 10" fill="none"><path d="M8 2L2 8M2 2l6 6" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg></button>' +
        '</div>';
      }).join('');
      body.innerHTML = shipHTML + itemsHTML;
      var foot = document.getElementById('cdFoot');
      if (foot) {
        foot.innerHTML =
          '<div class="cd-sub"><span>Subtotal</span><span>' + fmoney(total) + '</span></div>' +
          '<a href="/checkout" class="btn-checkout">Checkout · ' + fmoney(total) + '</a>' +
          '<a href="/cart" class="btn-continue" style="margin-top:8px">View Cart</a>' +
          '<div class="cd-cod"><svg viewBox="0 0 12 12" fill="none"><rect x="1" y="2.5" width="10" height="7" rx="1.2" stroke="currentColor" stroke-width="1.1"/><path d="M1 5h10" stroke="currentColor" stroke-width="1.1"/></svg>COD available · 15-day returns</div>';
      }
    });
  }

  function updateCart(variantId, qty) {
    var updates = {};
    updates[variantId] = qty;
    fetch('/cart/update.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({updates: updates}) })
    .then(function(r){ return r.json(); })
    .then(function(){ loadCartDrawer(); });
  }

  function fmoney(cents) {
    return 'Rs.\u00a0' + Math.round(cents/100).toLocaleString('en-PK');
  }

  /* ── MOBILE MENU ── */
  function openMenu() {
    var m = document.getElementById('mobMenu');
    if (m) { m.classList.add('open'); document.body.style.overflow = 'hidden'; }
  }
  function closeMenu() {
    var m = document.getElementById('mobMenu');
    if (m) { m.classList.remove('open'); document.body.style.overflow = ''; }
  }

  /* ── REVEAL ── */
  function initReveal() {
    var els = document.querySelectorAll('.rv,.rvl,.rvr');
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('on'); io.unobserve(e.target); } });
    }, {threshold:.07, rootMargin:'0px 0px -18px 0px'});
    els.forEach(function(el){ io.observe(el); });
  }

  /* ── ACCORDION ── */
  function initAcc(selector) {
    document.querySelectorAll((selector||'.acc-q')).forEach(function(btn){
      btn.addEventListener('click', function(){
        var row = btn.closest('.acc-row, .pp-acc-row');
        var open = row && row.classList.contains('open');
        var parent = row && row.parentElement;
        if (parent) parent.querySelectorAll('.acc-row.open, .pp-acc-row.open').forEach(function(r){ if(r!==row) r.classList.remove('open'); });
        if (row) row.classList.toggle('open', !open);
      });
    });
  }

  /* ── HEADER SCROLL ── */
  function initHeader() {
    var hdr = document.getElementById('hdr');
    if (!hdr) return;
    window.addEventListener('scroll', function(){ hdr.classList.toggle('up', window.scrollY > 8); }, {passive:true});
  }

  /* ── URGENCY (homepage bar) ── */
  function initUrgency() {
    var liveEl = document.getElementById('liveCount');
    if (liveEl) {
      var base = 42 + Math.ceil(Math.random()*15);
      liveEl.textContent = base;
      setInterval(function(){
        base += Math.random() > .5 ? Math.ceil(Math.random()*3) : -Math.ceil(Math.random()*2);
        base = Math.max(30, Math.min(70, base));
        liveEl.textContent = base;
      }, 4800);
    }
    var stockEl = document.getElementById('stockCount');
    if (stockEl) stockEl.textContent = [5,6,7,8,9][Math.floor(Math.random()*5)];
    var delivEl = document.getElementById('delivDate');
    if (delivEl) {
      var d = new Date(); d.setDate(d.getDate() + (d.getDay() >= 4 ? 7 : 4));
      var days = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
      var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      delivEl.textContent = days[d.getDay()] + ' ' + months[d.getMonth()] + ' ' + d.getDate();
    }
  }

  /* ── STICKY MOBILE CTA (homepage) ── */
  function initStickyCta() {
    var cta = document.getElementById('stickyCta');
    var hero = document.querySelector('.hero');
    if (!cta || !hero) return;
    var io2 = new IntersectionObserver(function(entries){
      var visible = !entries[0].isIntersecting;
      cta.classList.toggle('vis', visible);
      document.body.classList.toggle('has-sticky-cta', visible);
    }, {threshold:.1});
    io2.observe(hero);
  }

  /* ── INIT ── */
  document.addEventListener('DOMContentLoaded', function(){
    initHeader();
    initReveal();
    initAcc('.acc-q');
    initAcc('.pp-acc-q');
    initUrgency();
    initStickyCta();

    // Close cart on overlay click
    var ov = document.getElementById('cartOv');
    if (ov) ov.addEventListener('click', closeCart);

    // Close menu on overlay click
    var mm = document.getElementById('mobMenu');
    if (mm) mm.addEventListener('click', function(e){ if(e.target===mm) closeMenu(); });

    // ATC buttons with class atc-btn
    document.addEventListener('click', function(e){
      var btn = e.target.closest('.atc-btn');
      if (!btn) return;
      var vid = btn.dataset.vid || btn.closest('[data-vid]') && btn.closest('[data-vid]').dataset.vid;
      if (!vid) return;
      addToCart(parseInt(vid), 1, btn);
    });
  });

  return { addToCart:addToCart, updateCart:updateCart, openCart:openCart, closeCart:closeCart, updateBadge:updateBadge, openMenu:openMenu, closeMenu:closeMenu };

})();
